module.exports = __webpack_public_path__ + "static/media/AULAO-PRESENCIAL-LOGO-02.4ffabaf9.png";